import { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'

import * as h from 'h'
import { PopoutTransitionContainer } from 'components/Popout/PopoutTransitionContainer'
import ExpertiseSearchBar from 'components/ExpertiseSearchBar'
import FacultyGraph from 'components/FacultyGraph'
import ResultsIndicator from 'components/ResultsIndicator'

import { filterRequestsByNamespace } from 'utils'
import { expertiseTagline, informationalMessage } from 'config'

import styles from './styles.scss'

@observer(['ExpertiseStore', 'UiStore'])
export default class Expertise extends Component {
  autoFocus = true

  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------

  componentWillMount () {
    const { UiStore, ExpertiseStore, location } = this.props

    if (location.query.search) {
      this.autoFocus = false

      UiStore.expertiseFilters.search = location.query.search
      ExpertiseStore.fetchKeywordHints(hints => {
        const found = hints.find(hint =>
          hint.keyword.toLowerCase() === location.query.search.toLowerCase())
        if (found) {
          ExpertiseStore.selectedKeywordId = found.id
        }
      })
    }
  }

  componentWillUnmount () {
    this.props.ExpertiseStore.stopFetcher()
  }

  // --------------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------------

  get isRequesting () {
    return this.isRequestingKeywordHints || this.isRequestingFacultyHints
  }

  get isRequestingKeywordHints () {
    return filterRequestsByNamespace(this.props.UiStore.requests, 'keywordsearch').length > 0
  }

  get isRequestingFacultyHints () {
    return filterRequestsByNamespace(this.props.UiStore.requests, 'lincusfacultysearch').length > 0
  }

  // --------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------

  render () {
    const { ExpertiseStore } = this.props
    const { displayResults, keywordAnalysis, exactKeywordNotFound } = ExpertiseStore

    return h.div(h.ca(styles.expertise, { [styles.raised]: displayResults }),
      h.h(PopoutTransitionContainer, null, this.props.children),
      h.h2(h.ca(styles.title), expertiseTagline),
      h.h(ExpertiseSearchBar, {
        placeholder: 'Enter a keyword or faculty name...',
        isLoading: this.isRequesting,
        autoFocus: this.autoFocus,
        name: 'Expertise Search'
      }),
      h.div(h.ca(styles.facultyGraphContainer, { [styles.show]: keywordAnalysis }),
        h.maybe(keywordAnalysis,
          h.h(FacultyGraph, {
            ...h.ca(styles.facultyGraphContainers),
            data: keywordAnalysis,
            onFacultyClick: f => browserHistory.push(`/faculty/${f.id}`)
          })
        )
      ),
      h.maybe(displayResults && !keywordAnalysis,
        h.h(ResultsIndicator, {
          showProgress: this.isRequestingKeywordHints,
          hasResults: !exactKeywordNotFound
        })
      ),
      h.p(null, informationalMessage)

    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Expertise/index.js